export default {
  defaultPaymentMethod: "默認付款方式",
  creditCardDetails: "信用卡詳細信息",
  cardInfo: "付款方式",
  RemoveCreditCard: "移除信用卡",

  // popup
  actionRequiredBeforeRemovingThisCard: "移除此卡之前需要採取的行動",
  haveUnpaidCharges: "您有啟用中的產品尚有未支付的費用（{count} 信用點數）。",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "移除您最後的付款方式將會暫停您目前啟用的產品（例如工作流程）。請清除未付款項或新增其他信用卡，以避免服務中斷。",
  btnViewCharge: "查看費用",
  btnPayNow: "立即付款",
  RemoveCreditCard: "删除信用卡",

  // pending payments
  transactionDetails: "交易明細",
  accountAdmin: "帳戶管理員",
  btnPayNow: "現在支付",
  paymentAmount: "金額",
  totalChargeCredit: "待支付總額",
  tabPendingPayments: "待付款",
  paySuccess: "支付成功",

  // empty table content
  noPendingPayments: "無待付款",
  anyPendingChargesWillShowUp: "任何未决費用都會在付款時顯示在這裡。",

  settings_billing_title: "帳單與付款",
  settings_billing_desc:
    "透過清晰的付款資訊掌握帳單管理。從管理信用卡、查看詳細發票紀錄到監控待處理費用，此區域可幫助您保持有條不紊，確保訂閱順利進行。",
  invoice_no: "發票編號",
  transaction_date: "交易日期",
  transaction_details: "交易明細",
  transaction_amount: "金額",

  accpeted_cards: "支援的卡種",
  add_new_card: "新增卡片",
  set_as_default_payment_method: "設為預設付款方式",
  country_region: "國家/地區",
  digit3_4: "3 位數 / 4 位數",
  payment_security_tip: "您的付款資料已透過 SSL 加密安全處理。",

  payment_add_failed_title: "新增信用卡失敗",
  contact_support: "聯絡客服",
  try_later: "稍後再試",
  payment_add_failed_issue: "新增卡片時發生問題。",
  payment_add_failed_unavailable: "銀行伺服器無法連線，請稍後再試。",
  charge_remove_card: "扣款並移除卡片",
};

export const settings_billing_japanese = {
  defaultPaymentMethod: "デフォルト支払い方法",
  creditCardDetails: "クレジットカード詳細",
  cardInfo: "支払い方法",
  RemoveCreditCard: "クレジットカードを削除",

  // popup
  actionRequiredBeforeRemovingThisCard: "カード削除前に必要なアクション",
  haveUnpaidCharges: "有効な製品に未払い料金があります（{count} クレジット）。",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "最後の支払い方法を削除すると、現在有効な製品（例：ワークフロー）が一時停止されます。サービス中断を避けるため、未払いを解消するか新しいカードを追加してください。",
  btnViewCharge: "料金を表示",
  btnPayNow: "今すぐ支払う",
  RemoveCreditCard: "クレジットカードを削除",

  // pending payments
  transactionDetails: "取引明細",
  accountAdmin: "アカウント管理者",
  btnPayNow: "今すぐ支払う",
  paymentAmount: "金額",
  totalChargeCredit: "未払い総額",
  tabPendingPayments: "未払い",
  paySuccess: "支払い成功",

  // empty table content
  noPendingPayments: "未払いなし",
  anyPendingChargesWillShowUp: "未決済の料金はここに表示されます。",

  settings_billing_title: "請求と支払い",
  settings_billing_desc:
    "明確な支払い情報で請求管理を把握。クレジットカード管理、詳細な請求書記録の確認、未処理料金の監視まで、このエリアで整理整頓を保ち、サブスクリプションを円滑に進めます。",
  invoice_no: "請求書番号",
  transaction_date: "取引日",
  transaction_details: "取引詳細",
  transaction_amount: "金額",

  accpeted_cards: "対応カード",
  add_new_card: "新しいカードを追加",
  set_as_default_payment_method: "デフォルト支払い方法に設定",
  country_region: "国/地域",
  digit3_4: "3桁 / 4桁",
  payment_security_tip: "お支払い情報はSSL暗号化で安全に処理されます。",

  payment_add_failed_title: "クレジットカード追加失敗",
  contact_support: "サポートに連絡",
  try_later: "後で再試行",
  payment_add_failed_issue: "カード追加時に問題が発生しました。",
  payment_add_failed_unavailable: "銀行サーバーに接続できません。後ほどお試しください。",
  charge_remove_card: "課金してカードを削除"
};

export const settings_billing_korean = {
  defaultPaymentMethod: "기본 결제 수단",
  creditCardDetails: "신용카드 상세 정보",
  cardInfo: "결제 방법",
  RemoveCreditCard: "신용카드 제거",

  // popup
  actionRequiredBeforeRemovingThisCard: "카드 제거 전 필요한 조치",
  haveUnpaidCharges: "활성화된 제품에 미결제 요금이 있습니다({count} 크레딧).",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "마지막 결제 수단을 제거하면 현재 활성화된 제품(예: 워크플로우)이 일시 중지됩니다. 서비스 중단을 피하려면 미결제 금액을 정산하거나 새 카드를 추가하세요.",
  btnViewCharge: "요금 확인",
  btnPayNow: "지금 결제",
  RemoveCreditCard: "신용카드 삭제",

  // pending payments
  transactionDetails: "거래 내역",
  accountAdmin: "계정 관리자",
  btnPayNow: "지금 결제",
  paymentAmount: "금액",
  totalChargeCredit: "미결제 총액",
  tabPendingPayments: "미결제",
  paySuccess: "결제 성공",

  // empty table content
  noPendingPayments: "미결제 없음",
  anyPendingChargesWillShowUp: "미결제 요금은 결제 시 여기에 표시됩니다.",

  settings_billing_title: "청구 및 결제",
  settings_billing_desc:
    "명확한 결제 정보로 청구 관리를 파악하세요. 신용카드 관리, 상세한 청구서 기록 확인, 미처리 요금 모니터링까지, 이 영역에서 체계적으로 정리하여 구독을 원활하게 진행할 수 있습니다.",
  invoice_no: "청구서 번호",
  transaction_date: "거래 일자",
  transaction_details: "거래 상세",
  transaction_amount: "금액",

  accpeted_cards: "지원 카드",
  add_new_card: "새 카드 추가",
  set_as_default_payment_method: "기본 결제 수단으로 설정",
  country_region: "국가/지역",
  digit3_4: "3자리 / 4자리",
  payment_security_tip: "결제 정보는 SSL 암호화로 안전하게 처리됩니다.",

  payment_add_failed_title: "신용카드 추가 실패",
  contact_support: "고객 지원",
  try_later: "나중에 다시 시도",
  payment_add_failed_issue: "카드 추가 중 문제가 발생했습니다.",
  payment_add_failed_unavailable: "은행 서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.",
  charge_remove_card: "요금 청구 후 카드 삭제"
};

export const settings_billing_hindi = {
  defaultPaymentMethod: "डिफ़ॉल्ट भुगतान विधि",
  creditCardDetails: "क्रेडिट कार्ड विवरण",
  cardInfo: "भुगतान विधि",
  RemoveCreditCard: "क्रेडिट कार्ड हटाएं",

  // popup
  actionRequiredBeforeRemovingThisCard: "इस कार्ड को हटाने से पहले आवश्यक कार्रवाई",
  haveUnpaidCharges: "आपके सक्रिय उत्पादों पर बकाया शुल्क है ({count} क्रेडिट)।",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "अपना अंतिम भुगतान विधि हटाने से आपके वर्तमान सक्रिय उत्पाद (जैसे वर्कफ़्लो) निलंबित हो सकते हैं। सेवा बाधा से बचने के लिए बकाया राशि चुकाएं या नया कार्ड जोड़ें।",
  btnViewCharge: "शुल्क देखें",
  btnPayNow: "अभी भुगतान करें",
  RemoveCreditCard: "क्रेडिट कार्ड हटाएं",

  // pending payments
  transactionDetails: "लेन-देन विवरण",
  accountAdmin: "खाता प्रशासक",
  btnPayNow: "अभी भुगतान करें",
  paymentAmount: "राशि",
  totalChargeCredit: "बकाया कुल राशि",
  tabPendingPayments: "बकाया भुगतान",
  paySuccess: "भुगतान सफल",

  // empty table content
  noPendingPayments: "कोई बकाया भुगतान नहीं",
  anyPendingChargesWillShowUp: "कोई भी बकाया शुल्क भुगतान करते समय यहां दिखाई देगा।",

  settings_billing_title: "बिलिंग और भुगतान",
  settings_billing_desc:
    "स्पष्ट भुगतान जानकारी के साथ बिलिंग प्रबंधन को समझें। क्रेडिट कार्ड प्रबंधन, विस्तृत इनवॉइस रिकॉर्ड देखने से लेकर लंबित शुल्कों की निगरानी तक, यह क्षेत्र आपको व्यवस्थित रखने में मदद करता है, सुनिश्चित करता है कि आपकी सदस्यता सुचारू रूप से चले।",
  invoice_no: "इनवॉइस नंबर",
  transaction_date: "लेन-देन तिथि",
  transaction_details: "लेन-देन विवरण",
  transaction_amount: "राशि",

  accpeted_cards: "स्वीकृत कार्ड",
  add_new_card: "नया कार्ड जोड़ें",
  set_as_default_payment_method: "डिफ़ॉल्ट भुगतान विधि के रूप में सेट करें",
  country_region: "देश/क्षेत्र",
  digit3_4: "3 अंक / 4 अंक",
  payment_security_tip: "आपका भुगतान डेटा SSL एन्क्रिप्शन द्वारा सुरक्षित रूप से संसाधित किया जाता है।",

  payment_add_failed_title: "क्रेडिट कार्ड जोड़ने में विफल",
  contact_support: "सहायता से संपर्क करें",
  try_later: "बाद में पुनः प्रयास करें",
  payment_add_failed_issue: "कार्ड जोड़ते समय कोई समस्या हुई।",
  payment_add_failed_unavailable: "बैंक सर्वर उपलब्ध नहीं है, कृपया बाद में पुनः प्रयास करें।",
  charge_remove_card: "चार्ज करें और कार्ड हटाएं"
};